import { mapSuccessIndication } from '../../core';
import { ApiUpdateOptOutRequest } from '../interfaces';

export function mapOptOutRequest(optOut: boolean): ApiUpdateOptOutRequest {
    return {
        opt_out_indication: mapSuccessIndication(optOut),
    };
}
